(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nutrition-facts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const tab = e.target.closest('.nutrition-facts__tab');
    if (!tab) return;
    const root = tab.closest('.nutrition-facts');
    if (!root) return;
    const idx = tab.dataset.nfTab;
    root.querySelectorAll('.nutrition-facts__tab').forEach((t) => {
      const on = t.dataset.nfTab === idx;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-nf-panel]').forEach((p) => {
      p.hidden = p.dataset.nfPanel !== idx;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
